<template>
  <v-card>
    <v-card-title>{{ $t('transfer.title') }}</v-card-title>
    <template v-if="bank.active">
      <v-card-text v-if="!loading">
        <p>{{ $t('transfer.text', bank) }}</p>
        <br>
        <price-input v-model="amount" :config="{
            type: 'number',
            min: 0,
            max: max,
            required: true,
            hint: $t('transfer.hints.amount'),
            label: $t('transfer.labels.amount'),
          }"></price-input>
        <v-text-field
          :label="$t('transfer.labels.reference')"
          v-model="reference"
          counter
          max="12">
        </v-text-field>
      </v-card-text>
      <v-card-row actions>
        <v-btn
          @click.native.stop="transfer()"
          :disabled="amount <= 0"
          :loading="loading || loadingWallet"
          block primary light>
          {{ $t('transfer.submit') }}
        </v-btn>
      </v-card-row>
    </template>
    <template v-else>
      <v-card-text>
        <p>{{ $t('transfer.missingText') }}</p>
      </v-card-text>
      <v-card-row actions>
        <v-btn
          router :href="{ name: 'Account', params: { tab: 'bank' } }"
          :loading="loading || loadingWallet"
          primary block light>
          {{ $t('transfer.addBank') }}
        </v-btn>
      </v-card-row>
    </template>
  </v-card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { PriceInput } from '@/components/inputs'
  export default {
    components: {
      PriceInput
    },
    props: {
      maxAmount: {
        type: Number,
        required: true
      },
      currency: {
        type: String,
        required: true
      }
    },
    data () {
      const max = Math.min(this.maxAmount, process.env.MAX_PAYOUT_AMOUNT)
      return {
        max,
        reference: '',
        amount: max
      }
    },
    computed: mapGetters({
      bank: 'skiliko/bank/bank',
      loading: 'skiliko/bank/isLoading',
      loadingWallet: 'skiliko/wallets/isLoading'
    }),
    methods: {
      ...mapActions({
        fetchBank: 'skiliko/bank/fetchBank',
        _transfer: 'skiliko/wallets/transfer'
      }),
      transfer () {
        this._transfer({
          amount: this.amount,
          currency: this.currency,
          reference: this.reference
        })
          .then(_ => this.$emit('transferDone'))
      }
    },
    mounted () {
      this.fetchBank()
    },
    destroyed () {
      this.modal = false
      this.$parent.removeOverlay()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Transfer.vue